"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailMessage = void 0;
const typeorm_1 = require("typeorm/browser");
let EmailMessage = class EmailMessage {
};
__decorate([
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'character varying',
        length: 18,
        name: 'relatedtoid',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "relatedToId", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 1000,
        name: 'fromname',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "fromName", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 1000,
        name: 'fromaddress',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "fromAddress", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 4000,
        name: 'toaddress',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "toAddress", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 4000,
        name: 'ccaddress',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "ccAddress", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 4000,
        name: 'bccaddress',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "bccAddress", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 3000,
        name: 'subject',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "subject", void 0);
__decorate([
    (0, typeorm_1.Column)('timestamp without time zone', {
        nullable: false,
        default: () => "timezone('utc', now())",
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], EmailMessage.prototype, "createdDate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: false,
        name: 'htmlbody',
    }),
    __metadata("design:type", String)
], EmailMessage.prototype, "htmlBody", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean', {
        name: 'isdeleted',
    }),
    __metadata("design:type", Boolean)
], EmailMessage.prototype, "isDeleted", void 0);
EmailMessage = __decorate([
    (0, typeorm_1.Entity)('emailmessage', { schema: 'public', synchronize: false })
], EmailMessage);
exports.EmailMessage = EmailMessage;
//# sourceMappingURL=email-message.js.map